var _classCallCheck = require("/app/product-catalog-web/src/ClientApp/node_modules/@babel/runtime/helpers/classCallCheck.js").default;
var _createClass = require("/app/product-catalog-web/src/ClientApp/node_modules/@babel/runtime/helpers/createClass.js").default;
var _arguments = typeof arguments === "undefined" ? void 0 : arguments,
  _this = this;
/**
 * This shims VSS.SDK functionality so that the web app can be executed in the standalone mode (not as an VSS extension).
 */

VSS.isMock = !isLoadingInsideVSTS();
VSS.__ready = VSS.ready;
VSS.ready = function (callback) {
  if (!VSS.isMock) {
    VSS.__ready(callback);
    return;
  }

  // We're not in VSTS => shim everything!
  VSS.getWebContext = function () {
    return {
      user: {
        id: "1es-localdev-user"
      },
      account: {
        id: "1es-localdev-account",
        name: "1es-localdev-account"
      }
    };
  };
  VSS.__getService = VSS.getService;
  VSS.getService = function (contributionId) {
    if (contributionId === VSS.ServiceIds.Navigation) {
      return Promise.resolve(new NavigationMock());
    }
    return VSS.__getService.apply(_this, _arguments);
  };
  setTimeout(function () {
    return callback();
  }, 1000);
};
function isLoadingInsideVSTS() {
  try {
    return window.origin !== window.parent.origin;
  } catch (e) {
    return true;
  }
}
var NavigationMock = /*#__PURE__*/function () {
  "use strict";

  function NavigationMock() {
    _classCallCheck(this, NavigationMock);
  }
  _createClass(NavigationMock, [{
    key: "replaceHash",
    value: function replaceHash() {}
  }, {
    key: "onHashChanged",
    value: function onHashChanged() {}
  }, {
    key: "getHash",
    value: function getHash() {
      return Promise.resolve(window.location.pathname);
    }
  }, {
    key: "getCurrentState",
    value: function getCurrentState() {
      return Promise.resolve({});
    }
  }]);
  return NavigationMock;
}();